import { useMemo } from 'react';
import { get } from 'lodash';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { ADVISOR_ERROR_KEYS } from 'libs/redux-store/src/advisor/advisorSlice';

const ERROR_KEY_TO_LABEL_PATH: Record<string, string> = {
  [ADVISOR_ERROR_KEYS.INVALID_PARTY_ID]: 'formErrors.invalidPartyId',
  [ADVISOR_ERROR_KEYS.ALREADY_LINKED_PARTY_ID]: 'formErrors.alreadyLinkedPartyId',
  [ADVISOR_ERROR_KEYS.INVALID_COUNSELLOR_ID]: 'formErrors.invalidCounsellorId',
  [ADVISOR_ERROR_KEYS.ALREADY_LINKED_COUNSELLOR_ID]: 'formErrors.alreadyLinkedCounsellorId',
  [ADVISOR_ERROR_KEYS.LH_CODE_MISMATCH_ID]: 'formErrors.lhCodeMismatchId'
};

/**
 * Resolves field error keys to localized error messages
 */
export const useAdvisorFieldErrors = (
  fieldErrors: Record<string, string>,
  labels: Record<string, unknown>
): Record<string, string> => {
  return useMemo(() => {
    const resolved: Record<string, string> = {};

    Object.entries(fieldErrors).forEach(([field, errorKey]) => {
      const labelPath = ERROR_KEY_TO_LABEL_PATH[errorKey];
      resolved[field] = labelPath ? (get(labels, labelPath, errorKey) as string) : errorKey;
    });

    return resolved;
  }, [fieldErrors, labels]);
};
